<hvl-form-item [formGroup]="formGroup" label="{{ label | translate }}" key="{{ name }}">
    <p-checkbox [id]="inputId" [name]="name" [formControlName]="name" binary="true"></p-checkbox>
</hvl-form-item>
